module.exports = __webpack_public_path__ + "static/img/watch_ic1.fce00784.png";